import * as yup from 'yup';

yup.addMethod(yup.string, 'phoneNumber', () => {
  return this.matches(/^(8|9)\d{8,11}$/, 'Format nomor handphone tidak valid');
});

export default yup;
